import TextInput, {
  TEXT_INPUT_STYLES,
  type TextInputProps,
} from '@/components/common/TextInput/TextInput'
import TextInputWithClear from '@/components/common/TextInput/TextInputWithClear'

export { TextInputWithClear, type TextInputProps, TEXT_INPUT_STYLES }

export default TextInput
